/*
 * $Id:: userAreaTheme.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const theme = {
    breakpoints: {
        keys: ['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    palette: {
        white: '#FFFFFF',
        black: '#000000',
        primary: {
            main: '#455A64',
        },
        secondary: {
            main: '#1976D2', //'#01579B',
        },
        status: {
            warning: '#ff0000',
        },
        error: {
            main: '#D32F2F',
            border: '#F44336',
            label: '#B71C1C',
        },
        disabled: {
            main: '#191a1a',
            button: '#BDBDBD',
        },
        text: {
            primary: '#ECEFF1',
            outlined: '#546E7A',
            blackCommon: '#171C26',
            blue700: '#135FA5',
            blue900: '#00294E',
            blueGray: '#607D8B',
            chipgrey: '#5D5D5D',
            contrastGrey: '#424242',
            darkBlue: '#0D47A1',
            darkGrey: '#6B6C7E',
            detailsGrey: '#9E9E9E',
            grey700: '#303233',
            greyMain: '#586071',
            gridDetailTitle: '#272833',
            gridDetailValue: '#858585',
            inactiveChildGrey: '#858585',
            label: '#212121',
            lightBg: '#F1F2F5',
            linkBlue: '#1E88E5',
            listgrey: '#616161',
            mainBlue: '#1976D2',
            statusGreen: '#388E3C',
            tabgrey: '#78909C',
            tableValue: '#303233',
            value: '#757575',
        },
        scrollbar: {
            main: '#B8B8B8',
        },
        svg: {
            main: '#263238',
        },
        action: {
            dimGrey: '#B0BEC5',
            activeBlue: '#1565C0',
        },
        tab: {
            selected: '#135FA5',
        },
        paginator: {
            main: '#6B6C7E',
        },
        image: {
            background:
                'linear-gradient(45deg, #e7e7ed 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e7e7ed 75%), linear-gradient(45deg, transparent 75%, #e7e7ed 75%), linear-gradient(45deg, #e7e7ed 25%, transparent 25%)',
        },
    },
    spacing: 8,
    typography: {
        useNextVariants: true,
        htmlFontSize: 16,
        fontFamily: '"Open Sans", sans-serif',
        fontSize: 14,
        fontSizeSmall: 12,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        titleFontSize: 18,
        titleFontWeight: 600,
        h1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 10,
            fontSize: '95.56px',
            lineHeight: '130px',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 300,
            fontSize: '59.72px',
            lineHeight: '81px',
            letterSpacing: '-0.5px',
        },
        h3: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '47.39px',
            lineHeight: '65px',
            letterSpacing: '0em',
        },
        h4: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '33.57px',
            lineHeight: '46px',
            letterSpacing: '0.25px',
        },
        h5: {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '23.69px',
            lineHeight: '32px',
        },
        h6: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '19.74px',
            lineHeight: '27px',
            letterSpacing: '0.25px',
        },
        subtitle1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '15.8px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
        },
        subtitle2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 500,
            fontSize: '13.82px',
            lineHeight: '24px',
            letterSpacing: '0.1px',
        },
        body1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '15.8px',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            color: 'rgba(0,0,0,0.6)',
        },
        body2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '13.82px',
            lineHeight: '20px',
            letterSpacing: '0.25px',
        },
        button: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            // letterSpacing: '1.25px',
            textTransform: 'initial',
            color: 'rgba(0,0,0,0.87)',
        },
        caption: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '17px',
            letterSpacing: '0.41px',
            backgroundColor: '#424242',
            color: '#ffffff',
        },
        overline: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '2.03px',
            textTransform: 'uppercase',
            color: 'rgba(0,0,0,0.6)',
        },
    },
};

export default {
    ...theme,
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    overrides: {
        MuiButton: {
            root: {
                padding: '10px',
                color: theme.palette.text.primary,
                height: '40px',
                margin: '5px',
                minWidth: '75px', //'25px',
                fontFamily: theme.typography.button.fontFamily,
                fontSize: theme.typography.button.fontSize,
            },

            contained: {
                border: '1px solid ' + theme.palette.text.mainBlue,
                backgroundColor: theme.palette.text.mainBlue,
                color: theme.palette.text.primary,
                boxShadow: 'none',
                padding: '10px',
                '&:hover': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: theme.palette.text.mainBlue,
                    '@media': {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                },
                '&:active': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: theme.palette.text.mainBlue,
                },
                // Contained Button - Warning
                '&.warning': {
                    color: theme.palette.text.primary,
                    borderColor: theme.palette.error.border,
                    '&:hover': {
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                    '&:active': {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                },

                '&$disabled': {
                    backgroundColor: theme.palette.disabled.button,
                    border: 'none',
                    color: '#FFFFFF',
                },

                // Contained Button - medium Size

                '&.mediumSize': {
                    height: '36px',
                },

                //-----------------------------------MENU BUTTON---------------------------------------

                '&.menuButton': {
                    height: '30px',
                    width: '109px',
                    border: '1px solid #D6D6D6',
                    backgroundColor: '#F9F9F9',
                    fontSize: '13.8px',
                    letterSpacing: '1.25px',
                    lineHeight: '19px',
                    textAlign: 'center',
                },
                //------------------------------------------------------------------------------------
            },
            outlined: {
                border: '1px solid ' + theme.palette.text.mainBlue,
                color: theme.palette.text.mainBlue,
                padding: '10px',
                '&:hover': {
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                },
                '&:active': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                },
                // Outlined Button - Warning
                '&.warning': {
                    color: theme.palette.error.border,
                    borderColor: theme.palette.text.mainBlue,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&:active': {
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                    },
                },
                '&$disabled svg': {
                    fill: 'rgba(0, 0, 0, 0.26)',
                },

                // Outlined Button - medium Size

                '&.mediumSize': {
                    height: '36px',
                },

                //-----------------------------------MENU BUTTON---------------------------------------

                '&.menuButton': {
                    height: '30px',
                    width: '109px',
                    border: '1px solid #D6D6D6',
                    backgroundColor: '#F9F9F9',
                    fontSize: '13.8px',
                    letterSpacing: '1.25px',
                    lineHeight: '19px',
                    textAlign: 'center',
                },
                //------------------------------------------------------------------------------------
            },
            // Outlined Button - Primary
            outlinedPrimary: {
                color: theme.palette.text.primary,
                borderColor: theme.palette.text.mainBlue,
                '&:hover': {
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },

                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                },
                // Outlined Button - Primary - Medium Size

                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success
            outlinedSecondary: {
                borderColor: theme.palette.text.mainBlue,
                color: theme.palette.text.primary,
                '&:hover': {
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                },

                // Outlined Button - Success - Medium Size

                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success - Large Size

            outlinedSizeLarge: {
                height: '42px',
            },

            text: {
                padding: '10px',
                color: theme.palette.text.mainBlue, //text.listgrey,
            },
        },

        MuiIconButton: {
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                '&.Mui-disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'unset',
                },
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
        },
        MuiButtonGroup: {
            grouped: {
                margin: '0px',
                marginTop: '10px',
                marginLeft: '0px',
            },
        },

        MuiInput: {
            underline: {
                '&:before': {
                    content: '',
                },
                '&:after': {
                    content: '',
                },
            },
        },

        MuiFormLabel: {
            root: {
                '&.Mui-error': {
                    color: theme.palette.error.label,
                },
            },
        },

        MuiInputBase: {
            root: {
                color: theme.palette.primary.main,
                height: '24px',
                width: '265px',
                fontFamily: 'Open Sans',
                fontSize: '14px',
                border: '1px solid ' + theme.palette.action.dimGrey,
                borderRadius: '3px',
                '& input::placeholder': {
                    fontSize: '14px',
                    fontFamily: '"Open Sans Regular", sans-serif',
                },
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused': {
                    borderColor: theme.palette.primary.main,
                },
                '&.Mui-error': {
                    borderColor: theme.palette.error.main,
                },
                '& input::-ms-clear, input::-ms-reveal': {
                    display: 'none',
                },
            },

            input: {
                marginLeft: '6px',
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiAppBar: {
            root: {
                height: '65px',
                '& .MuiButton-root': {
                    color: theme.palette.primary.main,
                },
                '& .MuiButtonBase-root': {
                    // margin: '0 20px',
                },
                '& .MuiIconButton-root': {
                    height: '32px',
                    width: '32px',
                    padding: '0',

                    '& .MuiIconButton-label': {
                        height: '32px',
                        width: '32px',

                        '& .MuiSvgIcon-root': {
                            height: '32px',
                            width: '32px',

                            '& path': {
                                height: '32px',
                                width: '32px',
                            },
                        },
                    },
                },
                '& .right': {
                    marginLeft: 'auto',
                    marginRight: 0,
                },
            },
        },

        MuiDialog: {
            paper: {
                width: '520px',
                padding: '10px',
                boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1), 0px 1px 18px rgba(0, 0, 0, 0.02), 0px 6px 10px rgba(0, 0, 0, 0.04)',
                borderRadius: '3px',
                '@media (max-width:600px)': {
                    padding: '15px',
                },
            },
        },

        MuiBackdrop: {
            root: {
                backgroundColor: 'rgba(97, 97, 97, 0.8)', // base color is #616161
                // opacity: '0.8',
            },
        },
        MuiDialogTitle: {
            root: {
                padding: '20px',
                color: '#000000',
            },
        },
        MuiDialogContent: {
            root: {
                maxHeight: '360px',
                color: '#000000',
                padding: '0px 20px',
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiDialogContentText: {
            root: {
                color: '#000000',
            },
        },
        MuiTypography: {
            colorError: {
                color: theme.palette.error.main,
            },
        },

        MuiRadio: {
            root: {
                color: theme.palette.text.mainBlue,
            },
            colorSecondary: {
                '&$checked': {
                    color: theme.palette.text.mainBlue,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },

        MuiFormControlLabel: {
            label: {
                color: theme.palette.text.mainBlue,
                fontWeight: theme.typography.titleFontWeight,
                fontSize: theme.typography.titleFontSize,
            },
        },

        MuiPopover: {
            paper: {
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiListItem: {
            root: {
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: '16px',
            },
        },
        MuiListItemText: {
            root: {
                marginTop: 0,
                marginBottom: 0,
            },
            primary: {
                fontSize: '12px',
                letterSpacing: 'normal',
                color: theme.palette.text.listgrey,
            },
        },

        MuiChip: {
            root: {
                color: theme.palette.text.chipgrey,
                borderRadius: '50px',
                transition: 'none',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04)',
            },
            clickable: {
                '&:hover': {
                    backgroundColor: '#FFFFFF',
                },
                '&:focus': {
                    backgroundColor: '#FFFFFF',
                },
            },
            icon: {
                marginLeft: '10px',
            },
        },

        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent',
                },
            },
            icon: {
                top: 'calc(50% - 8px)',
                right: '10px',
            },
        },
        MuiCheckbox: {
            root: {
                '& .MuiIconButton-label': {
                    background: theme.palette.white,
                    borderRadius: '4px',
                },
            },
            colorSecondary: {
                '&$checked': {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },
        MuiTabs: {
            root: {
                '@media (max-width:960px)': {
                    display: 'inline-grid',
                },
            },
            indicator: {
                backgroundColor: theme.palette.text.darkBlue,
            },
            scroller: {
                overflowX: 'auto !important',
                flexWrap: 'wrap',
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiTab: {
            root: {
                fontWeight: 'normal',
            },
            textColorPrimary: {
                color: theme.palette.text.mainBlue,
                '&$selected': {
                    fontWeight: '600',
                    color: theme.palette.text.darkBlue,
                },
            },
        },

        MuiCard: {
            root: {
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04);',
                borderRadius: '5px',
            },
        },

        MuiCardContent: {
            root: {
                padding: '10px',
                '&:last-child': {
                    paddingBottom: '10px',
                },
            },
        },
        MuiTableContainer: {
            root: {
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiTableHead: {
            root: {
                backgroundColor: theme.palette.text.primary,
                borderTopLeftRadius: '5px',
                borderTopRightRadius: '5px',
                borderBottom: 'solid 1px #E7E7ED',
            },
        },
        MuiTableCell: {
            root: {
                padding: '0 16px',
                color: theme.palette.text.tableValue,
            },
            head: {
                height: '37px',
                color: theme.palette.text.tableValue,
                fontSize: '10px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
                '&:first-child': {
                    borderTopLeftRadius: '5px',
                },
                '&:last-child': {
                    borderTopRightRadius: '5px',
                },
                '& .MuiTableSortLabel-root': {
                    color: theme.palette.text.tableValue,
                },
                '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
                    color: theme.palette.text.tableValue,
                },
            },
            body: {
                height: '63px',
                color: theme.palette.text.tableValue,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        },
        MuiTablePagination: {
            root: {
                marginTop: '1rem',
                color: theme.palette.paginator.main,
                '& .MuiTypography-body2': {
                    fontWeight: '600',
                },
                '& .MuiInputBase-root': {
                    border: 'none',
                    width: 'auto',
                },
                '& .MuiSelect-icon': {
                    top: 'calc(50% - 14px)',
                    right: '0px',
                },
                '& .MuiSelect-root': {
                    fontWeight: '600',
                },
            },
        },

        MuiSnackbar: {
            root: {
                '&.MuiSnackbar-anchorOriginTopRight': {
                    top: '110px',
                    right: '40px',
                },
            },
        },
        MuiAlert: {
            root: {
                display: 'flex',
                alignItems: 'center',
                minHeight: '32px',
                minWidth: '200px',
                maxWidth: '500px',
                '&.MuiAlert-filledInfo': {
                    backgroundColor: theme.palette.text.mainBlue,
                    fontWeight: '600',
                    fontSize: '14px',
                },
                '& .MuiIconButton-root': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
                '& .MuiAlert-icon': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
                '& .MuiAlert-message': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
            },
        },
        MuiDrawer: {
            paper: {
                padding: '30px 30px 30px 15px',
                width: '250px',
            },
        },
        MuiPagination: {
            root: {
                color: theme.palette.text.darkGrey,
            },
        },
        MuiPaginationItem: {
            root: {
                margin: '0 1px',
                color: theme.palette.text.darkGrey,
                fontWeight: '600',
                fontSize: theme.typography.fontSize,
                lineHeight: '20px',
                '&.Mui-selected': {
                    color: theme.palette.text.gridDetailTitle,
                },
            },
        },
        MuiTooltip: {
            tooltip: {
                maxWidth: '250px',
                fontSize: theme.typography.caption.fontSize,
                lineHeight: theme.typography.caption.lineHeight,
                fontWeight: theme.typography.caption.fontWeight,
                backgroundColor: theme.typography.caption.backgroundColor,
                opacity: '.9',
                color: theme.typography.caption.color,
            },
            arrow: { color: theme.typography.caption.backgroundColor },
        },
        MUIRichTextEditor: {
            toolbar: {
                '& .MuiIconButton-colorPrimary': {
                    color: theme.palette.text.mainBlue,
                },
            },
            placeHolder: {
                padding: '10px',
                height: 'calc(100% - 70px)',
            },
            editor: {
                height: '150px',
                background: 'rgba(226, 228, 233, 0.2)',
                border: '1px solid #BEC4D0',
                borderRadius: '4px',
                padding: '10px',
                overflow: 'auto',
                fontSize: theme.typography.fontSize,
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
            editorReadOnly: { cursor: 'not-allowed' },
            editorContainer: {
                color: theme.palette.text.blackCommon,
                height: 'calc(100% - 20px)',
                '& .DraftEditor-root': {
                    height: '100%',
                    '& .DraftEditor-editorContainer': {
                        height: '100%',
                        '& .public-DraftEditor-content': {
                            height: '100%',
                        },
                    },
                },
            },
        },
    },
};
